import React from 'react';
import PropTypes from 'prop-types';
import FopCornerLabel from './FopCornerLabel';
import CouponView from './CouponView';

const couponState = {
  ACTIVE: 'ACTIVE',
  APPLIED: 'APPLIED',
  ALREADY_USED: 'ALREADY_USED',
  NO_COUPON: 'NO_COUPON',
};

function getCouponState(product, basketItems = []) {
  if (!product.coupon) {
    return couponState.NO_COUPON;
  }
  const { sku, coupon: { id } } = product;

  const basketItemWithCoupon = basketItems.find(item => item.coupon && id === item.coupon.id);
  if (basketItemWithCoupon) {
    if (sku === basketItemWithCoupon.sku) {
      return couponState.APPLIED;
    } else {
      return couponState.ALREADY_USED;
    }
  }
  return couponState.ACTIVE;
}

function FopCorner({ product, user, basketItems }) {
  const currentCouponState = getCouponState(product, basketItems);

  if ([couponState.ACTIVE, couponState.APPLIED].includes(currentCouponState)) {
    return <CouponView discount={product.coupon.discount} selected={currentCouponState === couponState.APPLIED} />;
  } else {
    return <FopCornerLabel product={product} user={user} />;
  }
}

FopCorner.propTypes = {
  product: PropTypes.shape({
    sku: PropTypes.string.isRequired,
    coupon: PropTypes.shape({
      id: PropTypes.string.isRequired,
      discount: PropTypes.number.isRequired,
    }),
  }).isRequired,
  basketItems: PropTypes.array,
  user: PropTypes.object,
};

export default React.memo(FopCorner);
